<template>
  <ValidationObserver ref="vobserver" v-slot="{ errors }">
    <quest-validation-summary :errors="errors"></quest-validation-summary>
    <quest-main
      id="exit-intent-form"
      :title="
        exitIntent && exitIntent.id ? exitIntent.name || '(untitled)' : 'Create Exit Intent'
      "
      :loading="loading"
      :saving="saving"
    >
      <template v-slot:head>
        <a
          @click="save()"
          class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm"
          ><font-awesome-icon
            icon="save"
            size="sm"
            class="text-white-50"
          ></font-awesome-icon>
          Save
        </a>
      </template>
      <template v-slot:body>
        <quest-card title="Basic Information">


          <div class="row">
            <div class="col-md-6">
              <quest-input
                id="title"
                label="Title"
                name="Title"
                v-model="exitIntent.name"
                :rules="{ [REQUIRED]: true }"
                help="Banner title"
              ></quest-input>
            </div>
            <div class="col-md-6">
              <quest-toggle
                id="isActive"
                label="Activate"
                v-model="exitIntent.isActive"
                checked="Enabled"
                unchecked="Disabled"
                help="Is the exit intent banner enabled for public display"
              />
            </div>
          </div>

          <quest-text-area
            id="copy"
            label="Copy"
            v-model="exitIntent.copy"
            help="Information regarding the call to action / intent"
          ></quest-text-area>

          <quest-input
            id="buttonText"
            label="Button Text"
            name="buttonText"
            v-model="exitIntent.buttonText"
            help="The text displayed on the banners' button"
          ></quest-input>

          <quest-input
            id="buttonUrl"
            label="Button URL"
            name="buttonUrl"
            v-model="exitIntent.buttonUrl"
            help="The URL navigated to when the banner button is clicked"
          ></quest-input>

          <quest-input
            id="idleTrigger"
            label="Idle Trigger"
            name="idleTrigger"
            v-model="exitIntent.idleTrigger"
            help="How many seconds it takes for popup to trigger during idle on mobile"
          ></quest-input>

          <div class="form-group">
            <label>Image</label>
            <div class="d-flex h-100">
              <quest-image
                :image="exitIntent.image"
                single
                @change="$refs.splash.open()"
              ></quest-image>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <quest-multi-select
                id="sites"
                label="Displayed sites"
                v-model="exitIntent.sites"
                :options="sites"
                help="The sites which may display this exit intent"
                uid="id"
                text="name"
              ></quest-multi-select>
            </div>
          </div>

          <quest-image-picker
            ref="splash"
            title="Select banner image"
            albumName="snippets"
            :current="[exitIntent.image]"
            @update="updateBanner"
            required
            manage
          ></quest-image-picker>
        </quest-card>
      </template>
    </quest-main>
  </ValidationObserver>
</template>

<script>
import { REQUIRED } from '@/validation-types'
import { success, error } from '../helpers'
import { mapState } from 'vuex'
import { ExitIntentService } from '../services'
import {
  QuestCard,
  QuestMain,
  QuestStatCard,
  QuestValidationSummary,
} from './structure'
import {
  QuestInput,
  QuestTextArea,
  QuestEditor,
  QuestDatePicker,
  QuestToggle,
  QuestSingleSelect,
  QuestMultiSelect,
  QuestImagePicker,
  QuestImage,
} from './form'

export default {
  name: 'exit-intent',
  components: {
    QuestCard,
    QuestMain,
    QuestInput,
    QuestTextArea,
    QuestEditor,
    QuestDatePicker,
    QuestToggle,
    QuestSingleSelect,
    QuestMultiSelect,
    QuestStatCard,
    QuestImagePicker,
    QuestImage,
    QuestValidationSummary,
  },
  data() {
    return {
      REQUIRED,
      exitIntent: {
        image: '',
        sites: [],
      },
      loading: true,
      saving: false,
    }
  },
  computed: {
    ...mapState(['sites']),
  },
  mounted() {
    this.load()
  },
  methods: {
    updateBanner(selected) {
      this.exitIntent.image = selected
    },
    async save() {
      if (!this.$refs.vobserver) return
      let validated = await this.$refs.vobserver.validate()
      if (!validated) {
        error('Please ensure all errors are resolved')
        return
      }
      this.saving = true
      try {
        if (this.exitIntent.id) {
          new ExitIntentService().update(this.exitIntent).then((data) => {
            if (data) {
              this.load()
              success(`Updated exit intent banner #`, this.exitIntent.name)
            } else {
              error(`Failed to update exit intent banner #`, this.exitIntent.name)
            }
          })
        } else {
          new ExitIntentService().add(this.exitIntent).then((data) => {
            if (data) {
              this.$router.push({
                name: 'exit-intents-edit',
                params: { id: data.value },
              })
              this.load()
              success(`Created exit intent banner #`, this.exitIntent.name)
            } else {
              error(`Failed to create exit intent banner #`, this.exitIntent.name)
            }
          })
        }
      } finally {
        this.saving = false
      }
    },
    load() {
      if (this.$route.params.id) {
        new ExitIntentService()
          .get(this.$route.params.id)
          .then((data) => (this.exitIntent = data))
          .catch((_) => (this.exitIntent = null))
          .finally((_) => {
            this.loading = false
            this.$nextTick(() => {
              if (this.$refs && this.$refs.vobserver) {
                this.$refs.vobserver.validate()
              }
            })
          })
      } else {
        this.loading = false
      }
    },
  },
}
</script>
